const PileInput: React.FC<any> = props => {
  const { onChange, field, isView } = props.cell.column

  return (
    <input
      disabled={isView}
      type='text'
      className='form-control form-control-sm'
      value={props.value}
      onChange={(e: any) => onChange(props.row.original.id, field, e.target.value)}
    />
  )
}

export default PileInput
